var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4373 5.62077L13.0001 5.4757V4.89451V4.08331C13.0001 3.53153 13.4483 3.08331 14.0001 3.08331C14.5519 3.08331 15.0001 3.53153 15.0001 4.08331V4.89451V5.4757L15.5629 5.62077C18.2589 6.3157 20.2501 8.75725 20.2501 11.6666V18.6666V19.041L20.5492 19.266L22.3425 20.615L22.3659 20.6325L22.3905 20.6482C22.4497 20.6859 22.4983 20.7378 22.5321 20.7993C22.5658 20.8607 22.5834 20.9297 22.5834 20.9998V21C22.5834 21.1105 22.5395 21.2165 22.4614 21.2946C22.3832 21.3727 22.2773 21.4166 22.1667 21.4166H14.0001H5.83341C5.72291 21.4166 5.61693 21.3727 5.53879 21.2946C5.46065 21.2165 5.41675 21.1105 5.41675 21L5.41675 20.9998C5.41673 20.9297 5.4344 20.8607 5.46811 20.7993C5.48617 20.7664 5.50853 20.7362 5.53449 20.7094L5.66028 20.6147L7.4513 19.2657L7.75008 19.0407V18.6666V11.6666C7.75008 8.75725 9.74127 6.3157 12.4373 5.62077ZM14.0001 24.9166C13.4016 24.9166 12.8766 24.578 12.6076 24.0833H15.3925C15.1236 24.578 14.5985 24.9166 14.0001 24.9166Z",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsDark);
export default __webpack_public_path__ + "static/media/notifications-dark.2c6aa5d4e26c8c48428c9e28d469b426.svg";
export { ForwardRef as ReactComponent };